import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';

/**
 *  SAJÁT WIFI ESZKÖZEIM – felhasználói oldal.
 *
 *  A felhasználó bejelenti a gépe MAC-címét, az admin elbírálja. A VLAN-t NEM ő
 *  választja: a szerepköre dönti el (diák → 20, dolgozó → 10), a gondviselő pedig
 *  egyáltalán nem jelenthet be eszközt. A szabályt a szerver is érvényesíti, itt
 *  csak megmutatjuk – így a felhasználó érti, mi fog történni.
 */
@Component({
  selector: 'app-eszkozeim',
  templateUrl: './eszkozeim.component.html',
  styleUrls: ['./eszkozeim.component.scss'],
})
export class EszkozeimComponent implements OnInit {
  intezmenyId = '';
  felhasznalo = '';
  loginMode = '';
  toltodik = false;

  eszkozok: any[] = [];
  vlanSzabaly: any = {};
  uj: any = { mac: '', device_name: '', megjegyzes: '' };
  kuldes = false;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.intezmenyId = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
    this.loginMode = await this.data.getFromStorage('loginmode');
    const meta: any = await this.data.getFromStorage('userMetadata');
    this.felhasznalo = meta?.username || meta?.oktazon || '';
    await this.betolt();
  }

  /** Bejelenthet-e egyáltalán: a gondviselő eszköze nem kerül az iskolai hálózatra. */
  get bejelenthet(): boolean { return !!this.vlanSzabaly[this.loginMode]; }
  get sajatVlan(): number | null { return this.vlanSzabaly[this.loginMode] ?? null; }

  async betolt() {
    if (!this.felhasznalo) return;
    this.toltodik = true;
    try {
      const r: any = await firstValueFrom(
        this.http.get(`/api/mac-allowlist/sajat/${encodeURIComponent(this.felhasznalo)}/${this.intezmenyId}`));
      this.eszkozok = r?.eszkozok || [];
      this.vlanSzabaly = r?.vlan_szabaly || {};
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az eszközök betöltése nem sikerült.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  async bekuld() {
    if (!this.uj.mac?.trim() || !this.uj.device_name?.trim()) {
      this.data.sendToast('A MAC-cím és az eszköz neve is kell.', 'warning');
      return;
    }
    this.kuldes = true;
    try {
      await firstValueFrom(this.http.post(`/api/mac-allowlist/kerelem/${this.intezmenyId}`, {
        ...this.uj, felhasznalo: this.felhasznalo, mod: this.loginMode,
      }));
      this.data.sendToast('Bejelentve. Az adminisztrátor elbírálja.', 'success');
      this.uj = { mac: '', device_name: '', megjegyzes: '' };
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A bejelentés nem sikerült.', 'error');
    } finally {
      this.kuldes = false;
    }
  }

  async visszavon(e: any) {
    if (!confirm(`Visszavonod a bejelentést? ${e.mac_formazott}`)) return;
    try {
      await firstValueFrom(this.http.delete(
        `/api/mac-allowlist/kerelem/${e.id}?felhasznalo=${encodeURIComponent(this.felhasznalo)}`));
      await this.betolt();
    } catch (err: any) {
      this.data.sendToast(err?.error?.error || 'A visszavonás nem sikerült.', 'error');
    }
  }

  allapotSzin(statusz: string) {
    return { kerelem: 'warning', jovahagyva: 'success', elutasitva: 'danger' }[statusz] || 'medium';
  }
  allapotNev(statusz: string) {
    return {
      kerelem: 'elbírálásra vár',
      jovahagyva: 'jóváhagyva – csatlakozhatsz',
      elutasitva: 'elutasítva',
    }[statusz] || statusz;
  }
}
